import store from '../../store';
import Errors from '../../Errors';
// import ProductRating from '../ProductRating.vue';
import PostCardMixin from '../../mixins/PostCardMixin';
// import RelatedProducts from './show/RelatedProducts.vue';

export default {
    // components: { ProductRating, RelatedProducts },

    mixins: [
        PostCardMixin,
    ],

    props: ['post', 'reviewCount', 'avgRating'],

    data() {
        return {
            activeTab: 'description',
            currentReviewPage: 1,
            fetchingReviews: false,
            reviews: {},
            addingNewReview: false,
            reviewForm: {},
            errors: new Errors(),
        };
    },

    computed: {
        // totalReviews() {
        //     if (! this.reviews.total) {
        //         return this.reviewCount;
        //     }
        //
        //     return this.reviews.total;
        // },
        //
        // ratingPercent() {
        //     return (this.avgRating / 5) * 100;
        // },
        //
        // emptyReviews() {
        //     return this.totalReviews === 0;
        // },
        //
        // totalReviewPage() {
        //     return Math.ceil(this.reviews.total / 4);
        // },
    },

    // created() {
    //     this.fetchReviews();
    // },

    methods: {

        // changeReviewPage(page) {
        //     this.currentReviewPage = page;
        //
        //     this.fetchReviews();
        // },

        fetchReviews() {
            // this.fetchingReviews = true;
            //
            // $.ajax({
            //     method: 'GET',
            //     url: route('products.reviews.index', {
            //         productId: this.product.id,
            //         page: this.currentReviewPage,
            //     }),
            // }).then((reviews) => {
            //     this.reviews = reviews;
            // }).catch((xhr) => {
            //     this.$notify(xhr.responseJSON.message);
            // }).always(() => {
            //     this.fetchingReviews = false;
            // });
        },

        addNewReview() {
            // this.addingNewReview = true;
            //
            // $.ajax({
            //     method: 'POST',
            //     url: route('products.reviews.store', { productId: this.product.id }),
            //     data: this.reviewForm,
            // }).then((review) => {
            //     this.reviewForm = {};
            //     this.reviews.total++;
            //     this.reviews.data.unshift(review);
            //
            //     $('.captcha-input').prev('img').trigger('click');
            // }).catch((xhr) => {
            //     if (xhr.status === 422) {
            //         this.errors.record(xhr.responseJSON.errors);
            //     } else {
            //         this.$notify(xhr.responseJSON.message);
            //     }
            // }).always(() => {
            //     this.addingNewReview = false;
            // });
        },
    },
};
